import React, { Component } from 'react';
import { message } from 'antd';

import { querySaveAnnouncement } from '@api/administrative/announcement';
import { goBack } from '@comm/BackBtn';
import FormBase from './FormBase';

class PageAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentDidMount() {}

  /**
   * 提交报销
   */
  handSubmit = item => {
    item.uuid = this.props.params.uuid;
    querySaveAnnouncement(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    return (
      <div>
        <FormBase
          data={this.state.dataInfo}
          goBack={goBack}
          handSubmit={this.handSubmit}
          dataInfo={dataInfo}
        />
      </div>
    );
  }
}

export default PageAdd;



// WEBPACK FOOTER //
// ./src/components/administrative/announcement/PageAdd.js